/** @jsxImportSource @emotion/react */
import { getEnableWriteGoogleCalendar, getEnableWriteGoogleCalendarResource } from "apis/google";

export const openGooglePopup = (
  callback?: (success: boolean, data: any, refreshToken: string, message?: string) => void
) => {
  const scopes = [
    "https://www.googleapis.com/auth/admin.directory.resource.calendar",
    "https://www.googleapis.com/auth/calendar",
  ];
  const url = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${
    process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID
  }&redirect_uri=${process.env.REACT_APP_WEB_URL}/google/redirect/sign-up&scope=${scopes.join(
    "+"
  )}&access_type=offline&prompt=consent`;

  const popup = window.open(url, "member-list", "width=600,height=800");
  let messageReceived = false;

  const handleMessage = async (event: MessageEvent) => {
    messageReceived = true;
    const { googleAccessToken, googleRefreshToken } = event.data;

    if (googleAccessToken) {
      const res = await getEnableWriteGoogleCalendar(googleAccessToken);
      if (res?.success) {
        callback?.(res.success, res.data ?? [], googleRefreshToken);
      } else {
        callback?.(
          res.success,
          null,
          googleRefreshToken,
          res.message ?? "구글 캘린더 목록을 가져오는데 실패하였습니다."
        );
      }
    }
    window.removeEventListener("message", handleMessage);
  };

  const timer = setInterval(() => {
    try {
      if (popup?.closed) {
        clearInterval(timer);

        if (!messageReceived) {
          callback?.(false, "close", "", "");
        }

        window.removeEventListener("message", handleMessage);
      }
    } catch (error) {
      console.error("Error detecting popup closed", error);
    }
  }, 1000);

  window.addEventListener("message", handleMessage);
};
